import { SvgIcon, SvgIconProps } from '@mui/material'
import React from 'react'

export const CTLogo: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 16 16">
            <path d="M15.8916 14.0103C15.8916 15.11 15.208 16 14.3635 16H1.52814C0.685389 16 0 15.11 0 14.0103V1.98973C0 0.889957 0.683641 0 1.52814 0H14.3635C15.208 0 15.8916 0.889957 15.8916 1.98973V14.012V14.0103Z" fill="#F36F2C" />
            <path d="M2.25977 8.51138L3.69873 6.1947L5.71294 9.6706L12.1874 4.1665L13.6264 6.63006L5.42445 11.8439L2.25977 8.51138Z" fill="white" />
        </SvgIcon>
    )
}
